import client from '../../client';

const RADAR_SEARCHES = {
  createSearch(params) {
    return client.post('/radar_searches', { radar_search: params })
  }
}

export default RADAR_SEARCHES;
